/* eslint-disable @typescript-eslint/naming-convention */
import type { bodyTypeMessagesScope } from '../../Services/Vehicle/Vehicle.messages';
import { type MessageOptions, transformOptionsByMessageIds } from './TransformOptionsByMessageId';

export type BodyTypeMessageId = keyof typeof bodyTypeMessagesScope;

const BODY_TYPES_BY_MESSAGE_ID: Record<BodyTypeMessageId, MessageOptions> = {
  bus: {
    ids: ['bus'],
    label: 'Bus',
  },
  hatchback: {
    ids: ['hatchback', 'compacte'],
    label: 'Hatchback',
  },
  convertible: {
    ids: ['cabrio', 'convertible', 'cabriolet'],
    label: 'Convertible',
  },
  compact: {
    ids: ['compact'],
    label: 'Compact',
  },
  coupe: {
    ids: ['coupe'],
    label: 'Coupe',
  },
  estate: {
    ids: ['estate', 'break'],
    label: 'Estate',
  },
  family: {
    ids: ['family'],
    label: 'Estate',
  },
  industrial: {
    ids: ['industrial'],
    label: 'Industrial',
  },
  saloon: {
    ids: ['saloon', 'berline'],
    label: 'Saloon',
  },
  sedan: {
    ids: ['sedan'],
    label: 'Saloon',
  },
  sport_tourer: {
    ids: ['sport_tourer'],
    label: 'Sport Tourer',
  },
  suv: {
    ids: ['suv'],
    label: 'SUV',
  },
  pickup: {
    ids: ['pickup'],
    label: 'Pick-up',
  },
  mpv: {
    ids: ['mpv', 'monospace'],
    label: 'MPV',
  },
  van: {
    ids: ['van', 'fourgon'],
    label: 'Van',
  },
  sportscar: {
    ids: ['sportscar'],
    label: 'Sportwagen',
  },
  transporter: {
    ids: ['transporter'],
    label: 'Transporter / Nutzfahrzeug',
  },
  motorhome: {
    ids: ['motorhome'],
    label: 'Wohnmobil oder wagen',
  },
  smallcar: {
    ids: ['smallcar'],
    label: 'Kleinwagen',
  },
  othercar: {
    ids: ['othercar'],
    label: 'othercar',
  },
};

export const BODY_TYPES = transformOptionsByMessageIds(BODY_TYPES_BY_MESSAGE_ID);
